<div class="header-container fullWidth">
  <div class="logo-container">
    <a (click)="toggleSidebar()" href="#" class="sidebar-toggle" *ngIf="!PresenterModusEnabled">
      <nb-icon icon="menu-2-outline" status="control"></nb-icon>
    </a>
    <div class="sidebar-toggle" *ngIf="PresenterModusEnabled"></div>
    <img src="/assets/images/logo.png" />
    <a class="logo" href="#" (click)="navigateHome()">TotalCare {{environmentName}} <span>portal</span></a>
  </div>

  <ngx-user-profile></ngx-user-profile>
  <ngx-user-language></ngx-user-language>
  <ngx-user-logo style="margin-left: auto;"></ngx-user-logo>
</div>

<app-user-header [PresenterModusEnabled]="PresenterModusEnabled"></app-user-header>

<div class="header-container">
  <nb-actions size="small">
    <nb-action class="user-action" *nbIsGranted="['view', 'user']">
      <nb-user [nbContextMenu]="userMenu" [name]="user?.name" [picture]="user?.picture"
        nbContextMenuTag="user-context-menu">
      </nb-user>
    </nb-action>
  </nb-actions>
</div>

<dx-popup [(visible)]="mfaResetPopupVisible" [showTitle]="true"
  [title]=" 'GEBRUIKERMENU.MFA_RESET_GELUKT_TITLE' | translate" [width]="450" [height]="'auto'" [dragEnabled]="false"
  [closeOnOutsideClick]="false">
  <div *dxTemplate="let data of 'content'">
    <div style="padding: 20px;">
      <p style="margin-bottom: 20px;">
        {{'GEBRUIKERMENU.MFA_RESET_QUESTION' | translate}}
      </p>
      <div style="margin-bottom: 20px;">
        <label style="display: block; margin-bottom: 8px; font-weight: 500;">
          {{ 'GEBRUIKERMENU.MFA_RESET_REQUIRE_PASSWORD' | translate }}
        </label>
        <dx-text-box [(value)]="mfaResetPassword" mode="password" placeholder="Wachtwoord" [showClearButton]="true"
          (onEnterKey)="onMfaResetConfirm()">
        </dx-text-box>
        <div *ngIf="mfaResetErrorMessage" style="color: #d9534f; margin-top: 8px; font-size: 13px;">
          {{ mfaResetErrorMessage }}
        </div>
      </div>
      <div style="display: flex; gap: 10px; justify-content: flex-end;">
        <dx-button text="{{'GEBRUIKERMENU.MFA_RESET_BUTTON_CANCEL' | translate}}" (onClick)="onMfaResetCancel()">
        </dx-button>
        <dx-button text="{{'GEBRUIKERMENU.MFA_RESET_BUTTON_CONFIRM' | translate}}" type="default"
          (onClick)="onMfaResetConfirm()">
        </dx-button>
      </div>
    </div>
  </div>
</dx-popup>